import React from 'react';

import { GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton } from '@mui/x-data-grid-pro';
import Button from '@mui/material/Button';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { tokens, useTranslation } from '../utils/i18n';

// OSI-808: тулбар ОБЩИЙ — кроме ОСВ его используют разделы «Платежи» и «Корректировки».
// Поэтому правка строго аддитивная: все три пропса опциональны и приходят через
// componentsProps.toolbar. Там, где их не передали (а это все гриды, кроме OsvGrid),
// onToggleTotals === undefined, кнопка не рендерится и панель остаётся прежней.
// ВАЖНО: компонент намеренно БЕЗ observer/memo — см. комментарий OSI-808 в
// widgets/osi/abonents/ui/OsiAbonentsWidget.tsx: React.memo на тулбаре ломал
// внутреннее состояние GridToolbarColumnsButton (кнопка «Столбцы» переставала закрываться).
interface Props {
  /** Есть ли строки итогов по категориям, которые можно развернуть */
  hasTotalCategories?: boolean;
  /** Текущее состояние блока закреплённых строк итогов */
  isTotalsExpanded?: boolean;
  /** Переключить состояние; без обработчика кнопка не показывается */
  onToggleTotals?: () => void;
}

const DataGridToolBar: React.FC<Props> = ({
  hasTotalCategories = false,
  isTotalsExpanded = false,
  onToggleTotals
}) => {
  const { translateToken: tt } = useTranslation();

  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      {/* OSI-808: переключатель строк итогов по категориям услуг. Переехал сюда из подвала:
          на экранах с закреплённой строкой «ИТОГО» подвал скрывается как дублирующий,
          поэтому кнопке нужно место в панели над таблицей, рядом со «Столбцы»/«Фильтры». */}
      {hasTotalCategories && onToggleTotals && (
        <Button
          size="small"
          onClick={onToggleTotals}
          startIcon={isTotalsExpanded ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
        >
          {tt(
            isTotalsExpanded ? tokens.osiOSV.table.footer.hideCategories : tokens.osiOSV.table.footer.showCategories
          )}
        </Button>
      )}
    </GridToolbarContainer>
  );
};

export default DataGridToolBar;
